import React, { ReactNode } from 'react';

import { H2 } from '../../../../../../atoms/Heading/Heading';

import { ContentBody } from '../../../../../../atoms/ContentBody/ContentBody';
import { LoadingSpinner } from '../../../../../../atoms/LoadingSpinner/LoadingSpinner';
import { Text } from '../../../../../../atoms/Text/Text';
import { Header } from '../../../../../../organisms/Header/Header';
import { PageView } from '../../../../../../../models/analytics';
import {
  StyledCenterContainer,
  StyledFooter,
  TintedScreenWrapper,
} from './PendingAuthenticationScreen.styles';

type PendingAuthenticationScreenProps = {
  onBack?: () => void;
  title: ReactNode;
  primaryText: ReactNode;
  secondaryText?: ReactNode;
  primaryButton?: ReactNode;
};

export const PendingAuthenticationScreen: React.FC<PendingAuthenticationScreenProps> = ({
  onBack,
  title,
  primaryText,
  secondaryText,
  primaryButton,
}) => {
  return (
    <TintedScreenWrapper data-testid="awaiting-mobile-bankid-local">
      <Header onBack={onBack} hideCloseButton pageView={PageView.BANKID_LOCAL_AWAITING_SCREEN} />
      <ContentBody centerVertically>
        <StyledCenterContainer>
          <LoadingSpinner />
          <H2>{title}</H2>
          <Text>{primaryText}</Text>
        </StyledCenterContainer>
        {primaryButton && (
          <StyledFooter>
            {secondaryText && <Text color="secondary">{secondaryText}</Text>}
            {primaryButton}
          </StyledFooter>
        )}
      </ContentBody>
    </TintedScreenWrapper>
  );
};
